import { render, staticRenderFns } from "./category-card-calendar.vue?vue&type=template&id=893f2d46&scoped=true"
import script from "./category-card-calendar.vue?vue&type=script&lang=js"
export * from "./category-card-calendar.vue?vue&type=script&lang=js"
import style0 from "./category-card-calendar.vue?vue&type=style&index=0&id=893f2d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893f2d46",
  null
  
)

export default component.exports